import { FC } from "react";
import { Button } from "../../../components/Button";
import "./style.css";

interface Props {
  version: string;
  isChangelogSubmitButtonDisabled: boolean;
  onSubmitChangelogClick: () => void;
}

export const ChangelogHeader: FC<Props> = ({
  version,
  isChangelogSubmitButtonDisabled,
  onSubmitChangelogClick,
}) => {
  return (
    <div className="changelog-header-wrapper">
      <p>
        Changelog for version <span>{version}</span>
      </p>
      <Button
        disabled={isChangelogSubmitButtonDisabled}
        onClick={onSubmitChangelogClick}
      >
        Approve version
      </Button>
    </div>
  );
};
